<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title29"></a>
<div class="p-c"><span><strong class="b">FOR RUSSELL</strong></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429908573_ded01.vue?32f0e9b8